// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"2f28912b","1568":"1e32573f","3699":"4e76185d","4019":"4a3ce6f6","4483":"4a3ce6f6","5151":"4a3ce6f6","7768":"3261cd54"}[chunkId] + ".chunk.css";
};